import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaUsers, FaBuilding, FaBed } from "react-icons/fa";
import API from "./config/API";

function UsersDashboard() {
  const [userName, setUserName] = useState("");
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  // ================= API STATES =================
  const [floorsWiseBeds, setFloorsWiseBeds] = useState([]);
  const [roomsWiseBeds, setRoomsWiseBeds] = useState([]);
  const [availableBeds, setAvailableBeds] = useState([]);

  // ================= SELECTED STATES =================
  const [selectedFloor, setSelectedFloor] = useState("");
  const [selectedRoom, setSelectedRoom] = useState("");

  const navigate = useNavigate();

  // ================= GET USER =================
  useEffect(() => {
    const loggedUser = JSON.parse(localStorage.getItem("user") || "{}");

    if (loggedUser?.userName || loggedUser?.emailId) {
      setUserName(loggedUser.userName || loggedUser.emailId);
    }
  }, []);

  // ================= FETCH DASHBOARD DATA =================
  const fetchDashboardDetails = async (floorName = "", roomName = "") => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("user") || "{}");

      const payload = {
        emailId: loggedUser?.emailId || "",
        floorName: floorName,
        roomName: roomName,
      };

      const token = loggedUser?.jwtToken;

      console.log("Dashboard Payload:", payload);

      const response = await fetch(
        `${API.V1}/floor_rooms/getUserDashboardDetails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      console.log("Dashboard Response:", result);

      if (result?.statusCode === 200 && result?.data) {
        setFloorsWiseBeds(result.data.floorwiseBedsCount || []);

        setRoomsWiseBeds(result.data.roomwiseBedsCounts || []);

        setAvailableBeds(result.data.availbaleBeds || []);

        // ================= DEFAULT SELECTED FLOOR =================
        if (!floorName && result.data.floorwiseBedsCount?.length > 0) {
          setSelectedFloor(result.data.floorwiseBedsCount[0].floorName);
        } else {
          setSelectedFloor(floorName);
        }

        // ================= DEFAULT SELECTED ROOM =================
        if (!roomName && result.data.roomwiseBedsCounts?.length > 0) {
          setSelectedRoom(result.data.roomwiseBedsCounts[0].roomName);
        } else {
          setSelectedRoom(roomName);
        }
      } else {
        setFloorsWiseBeds([]);
        setRoomsWiseBeds([]);
        setAvailableBeds([]);
      }
    } catch (error) {
      console.error("Dashboard API Error:", error);

      setFloorsWiseBeds([]);
      setRoomsWiseBeds([]);
      setAvailableBeds([]);
    }
  };

  // ================= INITIAL LOAD =================
  useEffect(() => {
    fetchDashboardDetails();
  }, []);

  // ================= FLOOR CLICK =================
  const handleFloorClick = (floorName) => {
    setSelectedFloor(floorName);
    setSelectedRoom("");

    fetchDashboardDetails(floorName, "");
  };

  // ================= ROOM CLICK =================
  const handleRoomClick = (roomName) => {
    setSelectedRoom(roomName);

    fetchDashboardDetails(selectedFloor, roomName);
  };

  // ================= LOGOUT =================
  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("expiresIn");
    localStorage.removeItem("roleType");
    localStorage.removeItem("pgName");
    localStorage.removeItem("emailId");
    localStorage.removeItem("userId");

    navigate("/");
  };

  // ================= BED BOOKING =================
  const handleBedBooking = (bed) => {
    console.log("Selected Bed:", bed);

    navigate("/UserCompleteBookingForm", {
      state: {
        bedId: bed.bedId,
        bedName: bed.bedName,
        bedCost: bed.bedCost,
        bedCostPerDay: bed.bedCostPerDay,
        inOfferPrice_bedCost: bed.inOfferPrice_bedCost,
        isSnoringroom: bed.isSnoringroom,

        roomId: bed.roomId,
        roomName: bed.roomName,

        floorId: bed.floorId,
        floorName: bed.floorName,

        isAvailable: bed.isAvailable,
      },
    });
  };

  return (
    <div style={styles.container}>
      {/* ================= MAIN ================= */}
      <div style={styles.main}>
        {/* ================= HEADER ================= */}
        <div style={styles.header}>
          <div style={styles.marqueeContainer}>
            <div style={styles.marqueeText}>
              👋 Hi {userName}, Welcome To Users Dashboard
            </div>
          </div>

          {/* ================= PROFILE ================= */}
          <div style={styles.profileContainer}>
            <img
              src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
              alt="profile"
              style={styles.profileImg}
              onClick={() => setShowProfileMenu(!showProfileMenu)}
            />

            {showProfileMenu && (
              <div style={styles.profileMenu}>
                <Link
                  to="/updateProfile"
                  style={styles.menuItem}
                  onClick={() => setShowProfileMenu(false)}
                >
                  ✏ Update Profile
                </Link>

                <div style={styles.logout} onClick={handleLogout}>
                  🚪 Logout
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ================= CONTENT ================= */}
        <div style={styles.content}>
          <h1 style={styles.pageTitle}>Available Beds For User Registration</h1>

          <div style={styles.gridContainer}>
            {/* ================= FLOORS ================= */}
            <div style={styles.gridBox}>
              <div style={styles.gridHeaderBlue}>
                <FaBuilding />
                <span>Floors Wise Beds</span>
              </div>

              {floorsWiseBeds.length === 0 ? (
                <div style={styles.noData}>No floors available</div>
              ) : (
                floorsWiseBeds.map((item, index) => (
                  <div key={index} style={styles.row}>
                    <span
                      onClick={() => handleFloorClick(item.floorName)}
                      style={{
                        ...styles.clickableText,
                        color:
                          selectedFloor === item.floorName
                            ? "#2563eb"
                            : "#334155",
                      }}
                    >
                      {item.floorName}
                    </span>

                    <span style={styles.countBlue}>
                      {item.floorWisetotalBedsCount} Beds
                    </span>
                  </div>
                ))
              )}
            </div>

            {/* ================= ROOMS ================= */}
            <div style={styles.gridBox}>
              <div style={styles.gridHeaderGreen}>
                <FaBed />

                <span>
                  {selectedFloor ? `${selectedFloor} → ` : ""}
                  Rooms Wise Beds
                </span>
              </div>

              {roomsWiseBeds.length === 0 ? (
                <div style={styles.noData}>No rooms available</div>
              ) : (
                roomsWiseBeds.map((item, index) => (
                  <div key={index} style={styles.row}>
                    <span
                      onClick={() => handleRoomClick(item.roomName)}
                      style={{
                        ...styles.clickableText,
                        color:
                          selectedRoom === item.roomName
                            ? "#16a34a"
                            : "#334155",
                      }}
                    >
                      {item.roomName}
                    </span>

                    <span style={styles.countGreen}>
                      {item.roomWiseBedsCount} Beds
                    </span>
                  </div>
                ))
              )}
            </div>

            {/* ================= AVAILABLE BEDS ================= */}
            <div style={styles.gridBox}>
              <div style={styles.gridHeaderOrange}>
                <FaUsers />

                <span>
                  {selectedFloor ? `${selectedFloor} → ` : ""}
                  {selectedRoom ? `${selectedRoom} → ` : ""}
                  Available Beds ({availableBeds.length})
                </span>
              </div>

              {availableBeds.length === 0 ? (
                <div style={styles.noData}>No available beds</div>
              ) : (
                availableBeds.map((item, index) => (
                  <div key={index} style={styles.row}>
                    <span
                      onClick={() => item.isAvailable && handleBedBooking(item)}
                      style={{
                        ...styles.bedLink,
                        cursor: item.isAvailable ? "pointer" : "not-allowed",
                        opacity: item.isAvailable ? 1 : 0.6,
                      }}
                    >
                      {item.bedName} -{" "}
                      <span
                        style={{
                          color: "#dc2626",
                          fontWeight: "bold",
                        }}
                      >
                        ₹{item.bedCost}
                      </span>
                    </span>

                    <span
                      style={{
                        ...styles.countOrange,
                        color: item.isAvailable ? "#16a34a" : "#dc2626",
                      }}
                    >
                      {item.isAvailable ? "Available" : "Occupied"}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        {/* ================= FOOTER ================= */}
        <div style={styles.footer}>
          <div style={styles.footerLeft}>
            SVK Solutions PG Management System
          </div>

          <div style={styles.footerRight}>
            svksolutions@support.com | All Rights Reserved 2026
          </div>
        </div>
      </div>
    </div>
  );
}

export default UsersDashboard;

/* ============================================================
                          STYLES
============================================================ */

const styles = {
  // ================= MAIN CONTAINER =================
  container: {
    minHeight: "100vh",
    background: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
  },

  main: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  },

  // ================= HEADER =================
  header: {
    height: "70px",
    background: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 25px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    overflow: "visible",
    position: "relative",
    zIndex: 1000,
  },

  marqueeContainer: {
    width: "85%",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },

  marqueeText: {
    display: "inline-block",
    fontSize: "22px",
    fontWeight: "bold",
    color: "#dc2626",
    paddingLeft: "100%",
    animation: "moveText 12s linear infinite",
  },

  // ================= PROFILE =================
  profileContainer: {
    position: "relative",
    zIndex: 2000,
  },

  profileImg: {
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    cursor: "pointer",
    border: "2px solid #0ea5e9",
  },

  profileMenu: {
    position: "absolute",
    right: 0,
    top: "55px",
    width: "190px",
    background: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0 8px 25px rgba(0,0,0,0.18)",
    overflow: "hidden",
    zIndex: 9999,
  },

  menuItem: {
    display: "block",
    padding: "14px",
    textDecoration: "none",
    color: "#111827",
    borderBottom: "1px solid #e5e7eb",
    fontWeight: "600",
  },

  logout: {
    padding: "14px",
    color: "#dc2626",
    cursor: "pointer",
    fontWeight: "600",
  },

  // ================= CONTENT =================
  content: {
    flex: 1,
    width: "100%",
    boxSizing: "border-box",
    padding: "30px",
  },

  pageTitle: {
    textAlign: "center",
    marginBottom: "30px",
    color: "#0f172a",
    fontSize: "32px",
    fontWeight: "bold",
  },

  // ================= GRID =================
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "25px",
    width: "100%",
  },

  gridBox: {
    background: "#ffffff",
    borderRadius: "16px",
    padding: "22px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
    minHeight: "200px",
    boxSizing: "border-box",
  },

  // ================= HEADERS =================
  gridHeaderBlue: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: "#2563eb",
    color: "#ffffff",
    padding: "14px",
    borderRadius: "10px",
    fontWeight: "bold",
    marginBottom: "20px",
    fontSize: "18px",
  },

  gridHeaderGreen: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: "#16a34a",
    color: "#ffffff",
    padding: "14px",
    borderRadius: "10px",
    fontWeight: "bold",
    marginBottom: "20px",
    fontSize: "18px",
  },

  gridHeaderOrange: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: "#ea580c",
    color: "#ffffff",
    padding: "14px",
    borderRadius: "10px",
    fontWeight: "bold",
    marginBottom: "20px",
    fontSize: "18px",
  },

  // ================= ROW =================
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "15px",
    padding: "12px 0",
    borderBottom: "1px solid #e2e8f0",
    fontWeight: "600",
    color: "#334155",
  },

  clickableText: {
    cursor: "pointer",
    textDecoration: "underline",
    fontWeight: "bold",
  },

  bedLink: {
    color: "#2563eb",
    fontWeight: "bold",
    textDecoration: "underline",
    transition: "0.3s",
  },

  // ================= COUNTS =================
  countBlue: {
    color: "#2563eb",
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },

  countGreen: {
    color: "#16a34a",
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },

  countOrange: {
    color: "#ea580c",
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },

  noData: {
    textAlign: "center",
    padding: "30px 10px",
    color: "#64748b",
    fontWeight: "600",
  },

  // ================= FOOTER =================
  footer: {
    minHeight: "50px",
    background: "linear-gradient(to right, #0ea5e9, #38bdf8)",
    color: "#ffffff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    fontSize: "15px",
    fontWeight: "bold",
    boxSizing: "border-box",
  },

  footerLeft: {
    fontSize: "18px",
  },

  footerRight: {
    fontSize: "14px",
  },
};
